import { z } from 'zod';

export const CompleteKitRegistrationResponseSchema = z.object({
  kitId: z.uuid(),
});

export type CompleteKitRegistrationResponse = z.infer<typeof CompleteKitRegistrationResponseSchema>;

export const DiscardKitDraftResponseSchema = z.object({
  kitId: z.uuid(),
});

export type DiscardKitDraftResponse = z.infer<typeof DiscardKitDraftResponseSchema>;
